import { createReducer, combineReducers } from "@reduxjs/toolkit";

import {
  createRequestReducerFromThunk,
  createIndexedRequestReducerFromThunk,
} from "@skydio/redux_util/src";

import { fetchLogbookFlights, fetchLogbookFlight, ingestLog, restoreLog } from "./asyncThunks";

import { LogbookFlightsMap } from "./types";

const flights = createReducer({} as LogbookFlightsMap, builder =>
  builder
    .addCase(fetchLogbookFlights.fulfilled, (state, { payload }) => {
      Object.assign(state, payload);
    })
    .addCase(fetchLogbookFlight.fulfilled, (state, { payload }) => {
      Object.assign(state, payload);
    })
);

const reducer = combineReducers({
  flights,
  requests: combineReducers({
    flights: createRequestReducerFromThunk(fetchLogbookFlights),
    flight: createIndexedRequestReducerFromThunk(fetchLogbookFlight),
    ingestLog: createIndexedRequestReducerFromThunk(ingestLog, "flightId"),
    restoreLog: createIndexedRequestReducerFromThunk(restoreLog, "flightId"),
  }),
});
export type LogbookState = ReturnType<typeof reducer>;
export default reducer;
